export const loadFromLocal = (key) => {
  try {
    const savedValue = JSON.parse(localStorage.getItem(key))

    if (savedValue === null) {
      return undefined
    }

    const { value, expiration, timestamp } = savedValue
    const isExpired = timestamp + expiration < Date.now()

    if (isExpired) {
      localStorage.removeItem(key)
      return undefined
    }

    return value
  } catch (error) {
    return undefined
  }
}

export const saveToLocal = (key, value, expiration) => {
  try {
    const savedValue = JSON.stringify({
      timestamp: Date.now(),
      expiration: expiration || 86400000, // one day
      value,
    })
    localStorage.setItem(key, savedValue)
  } catch (error) {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/shared/localStorage.js